/**
 * Growth Stages — Mastery visualization
 *
 * Maps mastery scores to visual growth stages (emoji, label, color).
 * Part of the Mastery domain (moved from utils/growthStages.ts).
 */

export interface GrowthStage {
  emoji: string;
  label: string;
  level: number;
  color: string;
}
export function getGrowthStage(masteryScore: number): GrowthStage {
  if (masteryScore <= 0) {
    return {
      emoji: '🔘',
      label: 'Nieuw',
      level: 0,
      color: 'bg-slate-300'
    };
  }
  if (masteryScore < 25) {
    return {
      emoji: '⭐',
      label: 'Net begonnen',
      level: 1,
      color: 'bg-emerald-300'
    };
  }
  if (masteryScore < 50) {
    return {
      emoji: '💫',
      label: 'Groeit',
      level: 2,
      color: 'bg-emerald-400'
    };
  }
  if (masteryScore < 80) {
    return {
      emoji: '🔥',
      label: 'Goed op weg',
      level: 3,
      color: 'bg-emerald-500'
    };
  }
  if (masteryScore < 95) {
    return {
      emoji: '🏆',
      label: 'Sterk',
      level: 4,
      color: 'bg-amber-400'
    };
  }
  return {
    emoji: '👑',
    label: 'Meester!',
    level: 5,
    color: 'bg-amber-500'
  };
}